import React from 'react'
import Head from 'next/head'
import {
  GetServerSideProps,
  GetServerSidePropsContext,
  GetStaticPaths
} from 'next'
import { Container, PostTitle, PostBody } from '../../styles/pages/post'
import { getPost } from '../../services/posts'
import { Post as PostType } from '../../types/post'
import PostDate from '../../components/postDate'
import PostTags from '../../components/postTags'
import MarkdownViewer from '../../components/markdownViewer'

type PostProps = {
  post: PostType
}

const Post: React.FC<PostProps> = ({ post }) => {
  const { title, createdAt, body } = post
  return (
    <>
      <Head>
        <title>{title} - Ricardo Borges</title>
        <meta name="description" content={post.description} />
        <meta name="author" content="Ricardo Borges" />
        <meta name="keywords" content={post.tags.join(',')} />
      </Head>
      <Container>
        <PostTitle>{title}</PostTitle>
        <PostTags tags={post.tags} />
        <PostDate date={createdAt} />
        <PostBody>
          <MarkdownViewer text={body} />
        </PostBody>
      </Container>
    </>
  )
}

export const getStaticProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const post = await getPost(context.params.slug as string)
  if (!post) {
    return {
      notFound: true
    }
  }
  return {
    props: { post }
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export default Post
